<script setup>
/* global axios */
// Icerik bolumunun kabugu: baslik + ust sekmeler + alt ekran.
//
// NEDEN artik hesap bazli DEGIL: kullanicinin zihnindeki is "Instagram
// yonetmek" degil, "olustur -> planla -> yayinla -> sonucunu gor". Menuyu
// bagli hesaplara bolmek ayni metni her hesap icin bastan yazdiriyordu.
// Artik bir gonderi COK hesaba gider; hesap secimi Olustur ekranindaki bir
// alan, bolumun iskeleti degil.
//
// Sekmeler kenar cubugundaki alt maddelerle AYNI rotalara gider: kullanici
// hangisinden girerse girsin ayni ekrani gorur. Sira da ayni tutuluyor.
//
// Ham 'axios' PAKETINI ice aktarmiyoruz. Chatwoot kimlik basliklarini
// window.axios uzerinde tutuyor; paketten gelen ornek 401 doner.
import { computed, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';
import { useAdmin } from 'dashboard/composables/useAdmin';
import Button from 'dashboard/components-next/button/Button.vue';

const { t } = useI18n();
const route = useRoute();
const router = useRouter();
const { isAdmin } = useAdmin();

const accountId = computed(() => route.params.accountId);

// Sekme listesi. Kenar cubugundaki alt maddelerle AYNI anahtarlari
// kullaniyor (Sidebar.vue yamasi): etiketi tek yerde tutmazsak menu ile
// sekme zamanla ayri isimlere kayar.
const SEKMELER = [
  {
    ad: 'icerik_genel_bakis',
    anahtar: 'ICERIK.SEKME_GENEL_BAKIS',
    simge: 'i-lucide-layout-dashboard',
  },
  {
    ad: 'icerik_takvim',
    anahtar: 'ICERIK.SEKME_TAKVIM',
    simge: 'i-lucide-calendar-days',
  },
  {
    ad: 'icerik_liste',
    anahtar: 'ICERIK.SEKME_ICERIKLER',
    simge: 'i-lucide-layout-list',
  },
  {
    ad: 'icerik_olustur',
    anahtar: 'ICERIK.SEKME_OLUSTUR',
    simge: 'i-lucide-pen-line',
  },
  {
    ad: 'icerik_medya',
    anahtar: 'ICERIK.SEKME_MEDYA',
    simge: 'i-lucide-image',
  },
  {
    ad: 'icerik_taslaklar',
    anahtar: 'ICERIK.SEKME_TASLAKLAR',
    simge: 'i-lucide-file-pen-line',
  },
  {
    ad: 'icerik_yorumlar',
    anahtar: 'ICERIK.SEKME_YORUMLAR',
    simge: 'i-lucide-message-circle',
  },
  {
    ad: 'icerik_istatistik',
    anahtar: 'ICERIK.SEKME_ISTATISTIK',
    simge: 'i-lucide-bar-chart-3',
  },
  {
    ad: 'icerik_onaylar',
    anahtar: 'ICERIK.SEKME_ONAYLAR',
    simge: 'i-lucide-check-check',
  },
];

// --- Bagli hesap uyarisi ---------------------------------------------------
//
// Hic bagli hesap yoksa ya da hicbirinin jetonu paylasima yetmiyorsa, hangi
// ekranda olursa olsun kullanicinin bunu bilmesi gerekiyor: hazirladigi
// gonderi yayin anina kadar sessizce bekler, sonra hata verir. Uyariyi
// kabukta bir kez cekiyoruz, alt ekranlarin her biri ayni istegi tekrar
// etmesin.
//
// Uyari ekrani ENGELLEMEZ: taslak yazmak, medya yuklemek, gecmisi okumak
// hesap baglanmadan da anlamli isler.
const hesaplar = ref([]);
const hesapYuklendi = ref(false);

const hesapYok = computed(() => hesapYuklendi.value && !hesaplar.value.length);

const yayinlanabilirYok = computed(
  () =>
    hesapYuklendi.value &&
    hesaplar.value.length > 0 &&
    !hesaplar.value.some(h => h.yayinlanabilir)
);

const hesaplariYukle = async () => {
  try {
    const { data } = await axios.get(
      `/api/v1/accounts/${accountId.value}/icerik/hesaplar`
    );
    hesaplar.value = data.hesaplar || [];
    hesapYuklendi.value = true;
  } catch (e) {
    // NEDEN sessiz: bu istek yalnizca bir UYARI icin. Basarisiz olursa
    // kabukta kirmizi bir kutu gostermek, asil ekrani (ki kendi hatasini
    // kendisi gosteriyor) ikinci bir hatayla golgelemek olurdu. Uyari
    // cikmaz, is akisi durmaz.
    hesapYuklendi.value = false;
  }
};

onMounted(hesaplariYukle);

const gelenKutularinaGit = () =>
  router.push({
    name: 'settings_inbox_list',
    params: { accountId: accountId.value },
  });

// Uyari metni dort ihtimalin biri. Sablonda ic ice ucluk yazmak yerine
// burada seciyoruz: okunmasi da, eksik bir dalin fark edilmesi de kolay.
const uyariMetni = computed(() => {
  if (hesapYok.value) {
    return isAdmin.value
      ? t('ICERIK.HESAP_YOK_ACIKLAMA')
      : t('ICERIK.HESAP_YOK_ACIKLAMA_TEMSILCI');
  }
  return isAdmin.value
    ? t('ICERIK.YAYINLANAMAZ_HEPSI')
    : t('ICERIK.YAYINLANAMAZ_HEPSI_TEMSILCI');
});
</script>

<template>
  <div class="flex flex-col w-full h-full overflow-hidden bg-n-surface-1">
    <header class="flex flex-col gap-3 px-6 pt-4 border-b border-n-weak">
      <div class="flex flex-col gap-0.5">
        <h1 class="text-lg font-medium text-n-slate-12">
          {{ t('ICERIK.BASLIK') }}
        </h1>
        <p class="text-xs text-n-slate-11">{{ t('ICERIK.ALT_BASLIK') }}</p>
      </div>

      <!-- Sekmeler RouterLink: dugme olsaydi orta tikla yeni sekmede acmak,
           baglantiyi kopyalamak calismazdi. -->
      <nav
        class="flex gap-1 -mb-px overflow-x-auto"
        :aria-label="t('ICERIK.SEKMELER')"
      >
        <RouterLink
          v-for="sekme in SEKMELER"
          :key="sekme.ad"
          :to="{ name: sekme.ad, params: { accountId } }"
          class="flex items-center gap-1.5 px-3 py-2 text-sm whitespace-nowrap border-b-2 transition-colors"
          :class="
            route.name === sekme.ad
              ? 'border-n-brand text-n-slate-12 font-medium'
              : 'border-transparent text-n-slate-11 hover:text-n-slate-12'
          "
        >
          <span :class="sekme.simge" class="size-4 shrink-0" />
          {{ t(sekme.anahtar) }}
        </RouterLink>
      </nav>
    </header>

    <!-- Bagli hesap uyarisi. Yalnizca yonetici gelen kutusu ayarlarini
         acabilir; temsilciye dugme gostermek kapali bir kapiya yollamak
         olurdu. -->
    <div
      v-if="hesapYok || yayinlanabilirYok"
      class="flex flex-wrap items-center gap-3 px-6 py-3 border-b border-n-weak bg-n-alpha-1"
    >
      <span class="i-lucide-triangle-alert size-4 shrink-0 text-n-amber-11" />
      <p class="text-xs text-n-slate-11">{{ uyariMetni }}</p>
      <Button
        v-if="isAdmin"
        size="xs"
        variant="faded"
        icon="i-lucide-inbox"
        :label="t('ICERIK.HESAP_YOK_DUGME')"
        @click="gelenKutularinaGit"
      />
    </div>

    <div class="flex-1 overflow-auto">
      <RouterView />
    </div>
  </div>
</template>
